import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({ prefix: "tw-" });

// Join class names; later tw- utilities win over earlier ones of the same kind.
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
